import * as React from 'react'
// components
import { Link, Table } from 'components/UI'
import TableRow from '@mui/material/TableRow'
// context
import { TableManagementContext } from 'containers/Search/layers/BL'
import { PlanTypesPageContext } from 'containers/PlanTypes/layers/API'
// views
import { TableCell } from 'themes/views/tables'

const headers = [
  { id: 'item.description', sortable: true, left: true, label: 'DESCRIPTION' },
  { id: 'item.maximumNestedLevelsCount', sortable: true, left: true, label: 'NUMBER OF LEVELS' }
]

const PlanTypesTable: React.FC = () => {
  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, totalCount, refetch, isRefetching } = React.useContext(PlanTypesPageContext)

  return (
    <Table
      data={data}
      page={page}
      headers={headers}
      perPage={perPage}
      refetch={refetch}
      title='Plan Types'
      totalCount={totalCount}
      isLoading={isRefetching}
      onPageChange={handleSetPage}
      onPerPageChange={handleSetPerPage}>
      {({ data }) =>
        data.map(({ id, companyId, description, maximumNestedLevelsCount }) => (
          <TableRow key={id} hover>
            <TableCell>
              <Link href={`/settings/plan-types/${id}?companyId=${companyId}`}>{description}</Link>
            </TableCell>
            <TableCell>{maximumNestedLevelsCount}</TableCell>
          </TableRow>
        ))
      }
    </Table>
  )
}

export default PlanTypesTable
